import { render, staticRenderFns } from "./customerSegmentCreate.vue?vue&type=template&id=73ab508a"
import script from "./customerSegmentCreate.vue?vue&type=script&lang=js"
export * from "./customerSegmentCreate.vue?vue&type=script&lang=js"
import style0 from "./customerSegmentCreate.vue?vue&type=style&index=0&id=73ab508a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports